import { DataFieldOption } from "../../shared/types/DataField";
import { useGetDataFieldTemplatesQuery } from "../services/dataFieldsSlice";

export const GetDataFieldOptionTemplate = (name: string, value: any): DataFieldOption | null => {
  const { data: dataFieldTempaltes } = useGetDataFieldTemplatesQuery();

  return dataFieldTempaltes
    ?.find((data: any) => data?.name === name)
    ?.dataFieldOptions.find((val: any) => val?.value === value) || null;
};
